import { toast } from 'react-toastify';
import { APP_CONSTANTS } from './AppConstants';
import {analytics, logEvent} from '../firebaseAnalytics'

export const displayErrorToast = message => {
    toast.error(message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: 123
    });
}

export const displaySuccessToast = message => {
    toast.success(message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        toastId: 123
    });
}

export const displayConsoleLog = (tag, message = '') => {
    if (process.env.NODE_ENV === 'development') {
        console.log(tag, message)
    }
}

let trim = (x) => {
    let value = String(x);
    return value.replace(/^\s+|\s+$/gm, "");
};

export const isEmpty = (value) => {
    if (
        value === null ||
        value === undefined ||
        trim(value) === "" ||
        value.length === 0
    ) {
        return true;
    } else {
        return false;
    }
};

export const isNull = (value) => {
    if (value === null ||
        value === undefined ||
        value.length === 0) {
        return true
    } else {
        return false
    }
}

export const isUserNotNull = (value) => {
    if (!isNull(value) && !isNull(value.data) && !isNull(value.data.userDetails))
        return true
    else return false
}

export const isValidEmail = (email) => {
    let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email.match(emailRegex)) {
        return true;
    } else {
        return false;
    }
};

export const convertToPascal = (text) => {
    return text.replace(/(\w)(\w*)/g,
        function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); })
}

export const removeSpecialCharAndChangeToPascal = (text) => {
    let text1 = text.replace(/[^a-zA-Z ]/g, " ")
    return text1.replace(/(\w)(\w*)/g,
        function (g0, g1, g2) { return g1.toUpperCase() + g2.toLowerCase(); })
}

export const addSpecialCharAndChangeToCamel = (text) => {
    let text1 = text.replace(" ", "_")
    return text1.replace(/(\w)(\w*)/g,
        function (g0, g1, g2) { return g1.toLowerCase() + g2.toLowerCase(); })
}

export const screenCaptureAnalytics = data => {
    logEvent(analytics, 'screen_view', {
        firebase_screen: data.screen,
        firebase_screen_class: data.screenClass
    })
}

export const convertToCamelcaseWithSpecialChar = (text) => {
    const arr = text.split(" ")
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].charAt(0).toLowerCase() + arr[i].slice(1);
    }
}


export const isLoggedInUserBusiness = (user) => {
    if (!isNull(user) && !isNull(user.data) && !isNull(user.data.userDetails) && !isEmpty(user.data.userDetails.userType) &&
        user.data.userDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.BUSINESS) {
        return true
    } else {
        return false
    }
}

export const isLoggedInUserEmployee = (user) => {
    if (!isNull(user) && !isNull(user.data) && !isNull(user.data.userDetails) && !isEmpty(user.data.userDetails.userType) &&
        user.data.userDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE) {
        return true
    } else {
        return false
    }
}

export const isLoggedInUserOperator = (user) => {
    if (!isNull(user) && !isNull(user.data) && !isNull(user.data.userDetails) && !isEmpty(user.data.userDetails.userType) &&
        user.data.userDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.OPERATOR) {
        return true
    } else {
        return false
    }
}

export const isLoggedInUserAdmin = (user) => {
    if (!isNull(user) && !isNull(user.data) && !isNull(user.data.userDetails) && !isEmpty(user.data.userDetails.userType) &&
        user.data.userDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.ADMIN) {
        return true
    } else {
        return false
    }
}

export const isLoggedInUserCustomer = (user) => {
    if (!isNull(user) && !isNull(user.data) && !isNull(user.data.userDetails) && !isEmpty(user.data.userDetails.userType) &&
        user.data.userDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.CUSTOMER) {
        return true
    } else {
        return false
    }
}

export const getDeviceType = (window) => {
    const userAgent = window.navigator.platform;

    if (/Win/i.test(userAgent)) {
        return APP_CONSTANTS.DEVICE_TYPE.WINDOWS;
    } else if (/Mac/i.test(userAgent)) {
        return APP_CONSTANTS.DEVICE_TYPE.MAC_OS;
    } else if (/Android/i.test(userAgent)) {
        return APP_CONSTANTS.DEVICE_TYPE.ANDROID;
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return APP_CONSTANTS.DEVICE_TYPE.IOS;
    } else {
        return userAgent;
    }
};

export const clearLocalStorage = () => {
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i)
        let isKeyToRetain = false
        if (isKeyToRetain === false) {
            localStorage.removeItem(key)
        }
    }
}

export const displayCurrencySymbolLeft = (region) => {
    if (region === 'Europe') {
        return false
    } else {
        return true
    }
}

export const numberToWords = (num) => {
    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"];
    const teens = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const thousands = ["", "Thousand", "Million", "Billion"];
  
    if (num === 0) return "Zero";
  
    let word = "";
    let i = 0;
  
    while (num > 0) {
      let part = num % 1000;
      if (part > 0) {
        word = helper(part) + thousands[i] + " " + word;
      }
      num = Math.floor(num / 1000);
      i++;
    }
  
    return word.trim();
  
    function helper(n) {
      if (n === 0) return "";
      else if (n < 10) return ones[n] + " ";
      else if (n < 20) return teens[n - 10] + " ";
      else if (n < 100) return tens[Math.floor(n / 10)] + " " + helper(n % 10);
      else return ones[Math.floor(n / 100)] + " Hundred " + helper(n % 100);
    }
  };